import Uploads from './List';
export default Uploads;